import * as React from 'react';
import Grid from '@mui/material/Grid';
import TitleGrid from './TitleGrid';

function removeDuplicates(arr) {
  return arr.filter((item, index) => arr.indexOf(item) === index);
}

function sortDates(dateArray) {
  return dateArray.sort((dateStr1, dateStr2) => {
    const [day1, month1, year1] = dateStr1.split('.').map(Number);
    const [day2, month2, year2] = dateStr2.split('.').map(Number);

    const date1 = new Date(year1, month1 - 1, day1);
    const date2 = new Date(year2, month2 - 1, day2);

    return date1 - date2;
  });
}

const SeatChart = (props) => {
  const { title, title2, json: pointJson, carJson } = props;
  const firstTable = [];
  const secondTable = [];

  let days = [];
  pointJson?.data?.forEach((el) => {
    el?.data?.forEach((element) => {
      days.push(element?.name);
    });
    days = removeDuplicates(days);
    days = sortDates(days);
  });

  const seats = carJson?.data[0]?.data[0]?.data;
  const shouldSplit = seats.length > 30;
  const half = shouldSplit ? Math.ceil(seats.length / 2) : seats.length;
  const firstHalfSeats = seats.slice(0, half);
  const secondHalfSeats = shouldSplit ? seats.slice(half) : [];

  carJson?.data?.forEach((date) => {
    date?.data?.forEach((transportation) => {
      transportation?.data?.forEach((seat) => {
        if (seat?.status === 2) {
          if (!shouldSplit || seat.seatNo < half) {
            firstTable.push({
              date: date?.name,
              seat: seat?.seatNo,
            });
          } else {
            secondTable.push({
              date: date?.name,
              seat: seat?.seatNo,
            });
          }
        }
      });
    });
  });

  const renderTable = (seatsArray, tableData) => (
    <div className="w-[1560px] p-5 flex">
      <div className="flex flex-col items-center justify-center w-8">
        <span className="-rotate-90 font-bold">Günler</span>
      </div>
      <div className="flex flex-col w-full">
        {carJson?.data?.map((date) => (
          <div className="flex w-full" key={date?.name}>
            <div className="w-24 border-r-2 border-black">{date?.name}</div>
            <div className="w-full ">
              <div className="flex w-full justify-center items-center">
                {seatsArray?.map((seat, index) => (
                  <div
                    className="bg-gray-100 flex flex-col w-full justify-center items-center"
                    key={index}
                  >
                    <div className="p-1 text-red-500 h-8 flex justify-center items-center">
                      {tableData?.filter(
                        (x) => x.date === date?.name && x.seat === seat?.seatNo,
                      ).length !== 0 ? (
                        <span className="bg-[#ff0000] w-8 h-5 text-white rounded-full p-1 flex justify-center items-center">
                          {
                            tableData?.filter(
                              (x) =>
                                x.date === date?.name &&
                                x.seat === seat?.seatNo,
                            ).length
                          }
                        </span>
                      ) : (
                        <span className="w-8 h-5 text-white rounded-full p-1 flex justify-center items-center">
                          {''}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
        <div className="w-full flex">
          <div className="w-24 bg-transparent"></div>
          <div className="flex w-full ">
            {seatsArray?.map((seat, index) => (
              <div
                className={`flex flex-col w-full border-t-2 border-black ${index % 2 === 0 ? '' : ''}`}
                key={index}
              >
                <div className="p-2">{seat?.seatNo}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col w-full">
          <span className="font-bold flex justify-end">Koltuk Sayısı</span>
          <div className="flex justify-center items-center">
            <span className="bg-[#ff0000] w-8 h-5 text-white rounded-full mr-1 p-1 flex justify-center items-center"></span>
            <span>Koltuğun Riskli Duruma Düşme Sayısı</span>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <Grid
      container
      spacing={2}
      style={{
        marginBottom: 10,
      }}
    >
      <TitleGrid
        title={title}
        title2={title2}
        widthRate={12}
        padding="10px"
        titleFontSize="h6"
      />
      {renderTable(firstHalfSeats, firstTable)}
      {secondHalfSeats.length > 0 && renderTable(secondHalfSeats, secondTable)}
    </Grid>
  );
};

export default SeatChart;
